const sideMenu = [
  {
    id: "summary",
    label: "Summary",
    href: "/app/summary",
    permissions: [1, 2, 10, 14]
  },
  {
    id: "approval_list",
    label: "Approval List",
    href: "/app/approval",
    permissions: [1]
  },
  {
    id: "reporting",
    label: "Reporting",
    permissions: [1, 2, 3, 8, 9, 11, 13, 14],
    isGroup: true,
    children: [
      {
        id: "report",
        label: "Report",
        href: "/app/report",
        permissions: [1, 2, 3, 13]
      },
      {
        id: "reportrange",
        label: "Report (Range)",
        href: "/app/range-report",
        permissions: [1, 2, 3, 13]
      },
      {
        id: "report_dashboard",
        label: "Report Dashboard",
        href: "/app/report/dashboard",
        permissions: [1, 2, 3, 13]
      },
      {
        id: "stock_opname",
        label: "Stock Opname",
        href: "/app/stock-opname",
        permissions: [1, 2, 3, 13]
      },
      {
        id: "sales",
        label: "Sales",
        href: "/app/sales",
        permissions: [1, 8, 14]
      },
      {
        id: "salesdashboard",
        label: "Sales Dashboard",
        href: "/app/dashboard",
        permissions: [1, 8, 9]
      },
      {
        id: "salesperformance",
        label: "Sales Performance",
        href: "/app/sales-performance",
        permissions: [1, 8, 13, 14]
      },
      {
        id: "pl",
        label: "P&L",
        href: "/app/pl",
        permissions: [1, 11, 13]
      }
    ]
  },
  {
    id: "data_management",
    label: "Data Management",
    permissions: [1, 2, 3],
    isGroup: true,
    children: [
      {
        id: "branch",
        label: "Branch",
        href: "/app/branch",
        permissions: [1, 2]
      },
      {
        id: "branch_group",
        label: "Branch Group",
        href: "/app/branch-group",
        permissions: [1, 2]
      },
      {
        id: "userlist",
        label: "User Management",
        href: "/app/users",
        permissions: [1, 2]
      },
      {
        id: "user_branch",
        label: "User Branch",
        href: "/app/user-branch",
        permissions: [1, 2]
      },
      {
        id: "commissionlist",
        label: "Commission Management",
        href: "/app/commission",
        permissions: [1, 2, 3]
      },
      {
        id: "coa",
        label: "COA Management",
        href: "/app/coa",
        permissions: [1, 11]
      }
    ]
  },
  {
    id: "division",
    label: "Division",
    href: "/app/division",
    permissions: [4, 5]
  },
  {
    id: "employee",
    label: "Employee",
    href: "/app/employee",
    permissions: [4, 5]
  },
  {
    id: "employee_group",
    label: "Employee Group",
    href: "/app/employee-group",
    permissions: [4, 5]
  },
  {
    id: "checkin",
    label: "Checkin / Checkout",
    href: "/app/checkin",
    permissions: [6]
  },
  {
    id: "dashboard",
    label: "Dashboard",
    href: "/app/attendance/dashboard",
    permissions: [6]
  },
  {
    id: "employee_performance",
    label: "Employee Performance",
    href: "/app/employee-performance",
    permissions: [4, 5]
  },
  {
    id: "mystery_shopper",
    label: "Mystery Shopper",
    href: "/app/mystery-shopper",
    permissions: [4, 5, 12]
  },
  {
    id: "reimburse",
    label: "Reimburse",
    href: "/app/reimburse",
    permissions: [1, 5, 6]
  },
  {
    id: "contract",
    label: "Contract",
    href: "/app/contract",
    permissions: [1, 5, 6]
  }
];

export default sideMenu;
